import type { Console } from './types.js';

// eslint-disable-next-line no-restricted-globals
export const stdConsole: Console = console;
